export const blockIconsActivitiesSwitchAccountNew = (
	<span className='material-symbols-outlined'>switch_account</span>
);
